import Vue from 'vue';
import App from './App.vue';
import dialog from './components/dialog/rgsdialog.vue';
import wjmmdialog from './components/dialog/wjmmdialog.vue';
import resetpassword from './components/dialog/resetpassword.vue';
import home from './components/home/home.vue';
import HomePage from './components/home/HomePage.vue';
import tree from './components/tree/tree.vue';
import ProductManagement from './components/ProductManagement/ProductManagement.vue';
import ProductManagementBJ from './components/ProductManagement/ProductManagementBJ.vue';
import AllProductManagement from './components/ProductManagement/AllProductManagement.vue';
import ContractCreation from './components/ContractManagement/ContractCreation.vue';
import ContractEnquiry from './components/ContractManagement/ContractEnquiry.vue';
import Modular from './components/product/Modular.vue';
import ModularTianjia from './components/product/ModularTianjia.vue';
import ModularBJ from './components/product/ModularBJ.vue';
import AllProducts from './components/AllProducts/AllProducts.vue';
import FormalProduct from './components/FormalProduct/FormalProduct.vue';
import Login from './components/login/login.vue';
import User from './components/User/User.vue';
import UserCore from './components/User/UserCore.vue';
import ExceedingTimes from './components/ToExamine/ExceedingTimes.vue';
import CodemeStock from './components/Codemeter/CodemeStock.vue';
import CodemeEdit from './components/Codemeter/CodemeEdit.vue';
import CodemeHistory from './components/Codemeter/CodemeHistory.vue';
import CodemeJurisdiction from './components/Codemeter/CodemeJurisdiction.vue';
import ErrorCollection from './components/ErrorCollection/ErrorCollection.vue';
import ErrorBeamHeight from './components/ErrorCollection/ErrorBeamHeight.vue';
import ProcurementContract from './components/Codemeter/ProcurementContract.vue';
import axios from 'axios';
import echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import { getaxiosurl } from "./components/path.js";
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.$getaxiosurl = getaxiosurl;
Vue.config.productionTip = false;
Vue.component('app-dialog', dialog);
Vue.component('app-User', User);
Vue.component('app-UserCore', UserCore);
Vue.component('app-ProductManagement', ProductManagement);
Vue.component('app-ProductManagementBJ', ProductManagementBJ);
Vue.component('app-AllProductManagement', AllProductManagement);
Vue.component('app-wjmmdialog', wjmmdialog);
Vue.component('app-home', home);
Vue.component('app-ErrorCollection', ErrorCollection);
Vue.component('app-ErrorBeamHeight', ErrorBeamHeight);
Vue.component('app-HomePage', HomePage);
Vue.component('app-tree', tree);
Vue.component('app-login', Login);
Vue.component('app-ContractCreation', ContractCreation);
Vue.component('app-ContractEnquiry', ContractEnquiry);
Vue.component('app-Modular', Modular);
Vue.component('app-ModularTianjia', ModularTianjia);
Vue.component('app-ModularBJ', ModularBJ);
Vue.component('app-AllProducts', AllProducts);
Vue.component('app-FormalProduct', FormalProduct);
Vue.component('app-ExceedingTimes', ExceedingTimes);
Vue.component('app-CodemeStock', CodemeStock);
Vue.component('app-CodemeEdit', CodemeEdit);
Vue.component('app-CodemeHistory', CodemeHistory);
Vue.component('app-ProcurementContract', ProcurementContract);
//解决vue-router重复点击导航报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login'
    }
    ,
    {
      path: '/resetpassword',
      name: 'resetpassword',
      component: resetpassword,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    }, {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/home/HomePage',
          name: 'HomePage',
          component: HomePage,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/home/ContractEnquiry',
          name: 'ContractEnquiry',
          component: ContractEnquiry,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/home/ProductManagement',
          name: 'ProductManagement',
          component: ProductManagement,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/home/ProductManagementBJ',
          name: 'ProductManagementBJ',
          component: ProductManagementBJ,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/home/AllProductManagement',
          name: 'AllProductManagement',
          component: AllProductManagement,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/home/AllProducts',
          name: 'AllProducts',
          component: AllProducts,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/FormalProduct',
          name: 'FormalProduct',
          component: FormalProduct,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/ExceedingTimes',
          name: 'ExceedingTimes',
          component: ExceedingTimes,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/CodemeStock',
          name: 'CodemeStock',
          component: CodemeStock,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/CodemeEdit',
          name: 'CodemeEdit',
          component: CodemeEdit,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/CodemeHistory',
          name: 'CodemeHistory',
          component: CodemeHistory,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/CodemeJurisdiction',
          name: 'CodemeJurisdiction',
          component: CodemeJurisdiction,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/ContractCreation',
          name: 'ContractCreation',
          component: ContractCreation,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/ProcurementContract',
          name: 'ProcurementContract',
          component: ProcurementContract,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/User',
          name: 'User',
          component: User,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/UserCore',
          name: 'UserCore',
          component: UserCore,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/ErrorCollection',
          name: 'ErrorCollection',
          component: ErrorCollection,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/home/ErrorBeamHeight',
          name: 'ErrorBeamHeight',
          component: ErrorBeamHeight,
          meta: {
            requireAuth: true
          }
        }
      ]
    },
  ]
});
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('userToken');
  if (to.meta.requireAuth) {
    if (token) {
      next();
      if (to.path == '/login' && from.path == '/home') {
        next({
          path: '/home'
        })
      }
    } else {
      next({
        path: '/login',
      });
    }
  }
  else {
    next();
  }
});
router.afterEach((to, from) => {
  if (from.path != '/login' && from.path != '/' && to.path == '/login') {
    window.location.reload();
  }
})

Vue.http.interceptors.push(function (request, next) {
  let tokenVal = sessionStorage.getItem('userToken');
  request.headers.set('Authorization', "Bearer" + tokenVal);
  next((res) => {
    if (res.data.code === '00191') {
      router.replace('/login');
      sessionStorage.removeItem("userToken");
      setTimeout(() => {
        this.$message({
          showClose: true,
          message: "登陆超时,请重新登陆",
          type: "success"
        });
      }, 0);
    } else {
      return res;
    }

  });
});

new Vue({
  axios,
  router,
  render: h => h(App),
}).$mount('#app')
